import { ExpertController } from "../ajax/ExpertController";
import { AdminController } from "../ajax/AdminController";

export function getRoles(): string[] {
  return (window as any)._roles as string[] ?? [];
}

export function isInRole(role: string): boolean {
  return getRoles()._where((r) => r.toLowerCase() === role.toLowerCase())._any();
}

export function refreshPendingCount() {
  if (isInRole("expert") || isInRole("admin")) {
    ExpertController.GetPendingCount().then((count) => {
      const dom = document.getElementById("nav-fund-count");
      if (dom == null) {
        return;
      }
      dom.style.display = count === 0 ? "none" : "";
      if (count > 99) {
        dom.textContent = "(99+)";
      } else {
        dom.textContent = "(" + count + ")";
      }
    });
  }
  if (isInRole("admin")) {
    AdminController.GetNewUserCount().then((usercount) => {
      const dom = document.getElementById("nav-user-count");
      if (dom == null) {
        return;
      }
      dom.style.display = usercount === 0 ? "none" : "";
      if (usercount > 99) {
        dom.textContent = "(99+)";
      } else {
        dom.textContent = "(" + usercount + ")";
      }
    });   
  }
}

export function correctDates(data: any): any {
  for (let key in data) {
    if (data[key] && typeof data[key] === "object")
      data[key] = correctDates(data[key]);
    else if (data[key] && dateISO.test(data[key].toString())) {
      let x = (Date as any).fromString(data[key]);
      data[key] = new Date(x.getTime() + (x.getTimezoneOffset() * 60000));
    }
  }
  return data;
}

var dateISO = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.*/i;

(function () {

  var d = window.Date as any;
  var regexIso8601 = /^(\d{4})-(\d{2})-(\d{2})((T)(\d{2}):(\d{2})(:(\d{2})(\.\d*)?)?)?(Z)?$/;


  d._myparse = function (v) {

    if (v.charAt(v.length - 1) !== "Z")
      v += "Z";
    var m = regexIso8601.exec(v);

    if (m) {
      return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[6] || 0, +m[7] || 0, +m[9] || 0, parseInt((+m[10]) * 1000 as any) || 0));
    }

    return d.parse.apply(this, arguments);
  };


  d.fromString = function (v) {
    return d._myparse(v);
  };

})();


Date.prototype.toISOString = function () {
  return toLocalIsoString(this);
};
function toLocalIsoString(date) {
  function pad(n) { return n < 10 ? '0' + n : n; }
  var localIsoString = date.getFullYear() + '-'
      + pad(date.getMonth() + 1) + '-'
      + pad(date.getDate()) + 'T'
      + pad(date.getHours()) + ':'
      + pad(date.getMinutes()) + ':'
      + pad(date.getSeconds()) + '.'
      + pad(date.getMilliseconds());
  if (date.getTimezoneOffset() === 0) localIsoString += 'Z';
  return localIsoString;
}